/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TabContentDirective } from './tab/tab-content.directive';
import { TabHeadingDirective } from './tab/tab-heading.directive';
import { TabDirective } from './tab/tab.directive';
import { TranscludeDirective } from './tab/transclude.directive';
import { TabsComponent } from './tabs.component';

@NgModule({
  imports: [CommonModule],
  declarations: [TabsComponent, TabContentDirective, TabDirective, TabHeadingDirective, TranscludeDirective],
  exports: [TabsComponent, TabContentDirective, TabDirective, TabHeadingDirective]
})
export class TabsModule {}
